(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brw-conversion-improvements"] && !Shopify.designMode) return;
  try {
    (() => {
    const bar = document.querySelector('[data-brw-purchase-bar]');
    const main = document.querySelector('section[id^="MainProduct-"]');
    try {
      if (/\/collections\//.test(location.pathname)) sessionStorage.setItem('brw_last_collection',location.pathname + location.search);
      if (/\/cart\/?$/.test(location.pathname)) {
        const last = sessionStorage.getItem('brw_last_collection');
        const destination = last ? new URL(last,location.origin) : null;
        if (destination && destination.origin === location.origin && /\/collections\//.test(destination.pathname)) {
          document.querySelectorAll('main a[href$="/collections/all"]').forEach(link => {link.href = destination.pathname + destination.search;});
        }
      }
    } catch (error) {}

    let scheduled = false;
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {scheduled = false; sync();});
    };
    const visible = element => {
      if (!element || !element.getClientRects().length) return false;
      const rect = element.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < innerHeight && getComputedStyle(element).visibility !== 'hidden';
    };
    const primary = () => main?.querySelector('product-form button[id^="ProductSubmitButton-"]');
    const sync = () => {
      const button = primary();
      if (bar && button) {
        const info = main.querySelector('.product-info-wrapper');
        const show = !!info && info.getBoundingClientRect().top < innerHeight - 80 && !visible(button);
        bar.hidden = !show;
        const action = bar.querySelector('[data-brw-purchase-action]');
        const needsOptions = bar.dataset.options === 'true' || !!main.querySelector('input[name^="properties["]');
        const busy = button.getAttribute('aria-disabled') === 'true';
        action.disabled = button.disabled || busy;
        const label = busy ? bar.dataset.busy : needsOptions ? bar.dataset.choose : button.textContent.replace(/\s+/g,' ').trim();
        if (action.textContent !== label) action.textContent = label;
        const price = [...main.querySelectorAll('[id^="price-"] .price-item')].find(el => el.offsetParent !== null);
        const target = bar.querySelector('[data-brw-purchase-price]');
        if (price && target.textContent !== price.textContent.trim()) target.textContent = price.textContent.trim();
      }
      const controls = [...document.querySelectorAll('.brw-hero-purchase button,.brw-card-actions button,.product-form__submit,.brw-action-stack a[href$="/checkout"],.mobile-facets__footer button')];
      const controlVisible = controls.some(el => {
        if (!visible(el)) return false;
        const rect = el.getBoundingClientRect();
        return rect.bottom > innerHeight - 260;
      });
      document.body.classList.toggle('brw-purchase-controls-visible',controlVisible || !!bar && !bar.hidden);
    };
    bar?.querySelector('[data-brw-purchase-action]').addEventListener('click', () => {
      const button = primary();
      if (!button) return;
      const needsOptions = bar.dataset.options === 'true' || !!main.querySelector('input[name^="properties["]');
      if (needsOptions) {
        const form = button.closest('.buy-buttons-block') || button;
        form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'center'});
        const option = [...form.querySelectorAll('select,input:not([type="hidden"]),button')].find(el => el.offsetParent !== null && !el.disabled);
        option?.focus({preventScroll:true});
      } else if (!button.disabled && button.getAttribute('aria-disabled') !== 'true') {
        button.click();
      }
    });
    if (main) new MutationObserver(schedule).observe(main,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
    document.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    document.addEventListener('click',schedule,true);
    document.addEventListener('shopify:section:load',schedule);
    sync();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["brw-footer-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('brw-footer-links')) {
    customElements.define('brw-footer-links', class extends HTMLElement {
      connectedCallback() {
        this.media = matchMedia('(min-width: 750px)');
        this.update = () => this.querySelectorAll('details').forEach(detail => { detail.open = this.media.matches; });
        this.update();
        this.media.addEventListener('change', this.update);
      }
      disconnectedCallback() { this.media.removeEventListener('change', this.update); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["brw-home-shortcut"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('brw-home-shortcut')) {
  customElements.define('brw-home-shortcut', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('.brw-home-shortcut__open');
      const android = /Android/i.test(navigator.userAgent);
      this.querySelector('[data-shortcut-device="ios"]').open = !android;
      this.querySelector('[data-shortcut-device="android"]').open = android;
      this.onInstallPrompt = event => { event.preventDefault(); this.installPrompt = event; };
      this.onInstalled = () => { this.hidden = true; this.installPrompt = null; if (dialog.open) dialog.close(); };
      window.addEventListener('beforeinstallprompt', this.onInstallPrompt);
      window.addEventListener('appinstalled', this.onInstalled);
      opener.addEventListener('click', async () => {
        if (this.installPrompt) {
          const prompt = this.installPrompt;
          this.installPrompt = null;
          try {
            await prompt.prompt();
            const choice = await prompt.userChoice;
            if (choice.outcome === 'accepted') this.hidden = true;
            return;
          } catch (error) {}
        }
        dialog.showModal();
        dialog.querySelector('h2').focus();
      });
      this.querySelectorAll('.brw-home-shortcut__close,.brw-home-shortcut__done').forEach(button => button.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => opener.focus());
      if (navigator.standalone) this.hidden = true;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["brw-new-product-ribbon"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('brw-new-product-ribbon')){
    customElements.define('brw-new-product-ribbon',class extends HTMLElement{
      connectedCallback(){
        this.checkExpiry=this.checkExpiry.bind(this);
        document.addEventListener('visibilitychange',this.checkExpiry);
        this.checkExpiry();
      }
      disconnectedCallback(){
        clearTimeout(this.expiryTimer);
        document.removeEventListener('visibilitychange',this.checkExpiry);
      }
      checkExpiry(){
        clearTimeout(this.expiryTimer);
        const remaining=Number(this.dataset.expires)-Date.now();
        if(!Number.isFinite(remaining)||remaining<=0){
          this.hidden=true;
          document.removeEventListener('visibilitychange',this.checkExpiry);
          return;
        }
        this.expiryTimer=setTimeout(this.checkExpiry,Math.min(remaining,3600000));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["brw-photo-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('brw-photo-navigation')) {
    customElements.define('brw-photo-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.menus = [...this.querySelectorAll('.brw-photo-details')];
        this.menus.forEach(menu => {
          menu.addEventListener('toggle', () => {
            if (menu.open) this.menus.forEach(other => { if (other !== menu) other.open = false; });
          }, options);
        });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            const open = this.menus.find(menu => menu.open);
            if (open) { event.preventDefault(); event.stopPropagation(); open.open = false; open.querySelector('summary').focus(); }
          }
        }, options);
        document.addEventListener('click', event => { if (!this.contains(event.target)) this.closeAll(); }, options);
        // Safari may blur a summary without focusing the clicked link. Keep it visible until navigation.
        this.addEventListener('focusout', event => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.closeAll();
        }, options);
        window.addEventListener('hashchange', () => this.closeAll(), options);
        window.addEventListener('resize', () => { if (window.innerWidth < 990) this.closeAll(); }, options);
      }
      closeAll() { this.menus.forEach(menu => { menu.open = false; }); }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["brw-product-experience"] && !Shopify.designMode) return;
  try {
    (() => {
  const labels = document.querySelector('[data-brw-rec-navigation]');
  if (!labels) return;
  const roots = new WeakSet();
  const styles = '.brw-rec-arrows{display:flex;justify-content:flex-end;gap:8px;padding:8px 2px 12px;position:static;clear:both}.brw-rec-arrows[hidden]{display:none!important}.brw-rec-arrows button{display:inline-flex;align-items:center;justify-content:center;flex:0 0 44px;width:44px;height:44px;min-height:44px;padding:0;border:1px solid #cebea2;border-radius:50%;background:#faf6ec;color:#233e32;cursor:pointer;box-shadow:none}.brw-rec-arrows button:hover:not(:disabled){background:#233e32;color:#faf6ec;border-color:#233e32}.brw-rec-arrows button:focus-visible{outline:3px solid #94691e;outline-offset:3px}.brw-rec-arrows button:disabled{opacity:.35;cursor:default}.brw-rec-arrows svg{display:block;width:18px;height:18px;pointer-events:none}';
  function bindRoot(root) {
    if (roots.has(root)) return;
    roots.add(root);
    const style = document.createElement('style');
    style.dataset.brwRecStyle = '';
    style.textContent = styles;
    root.appendChild(style);
    const rows = new Map();
    let scheduled = false;
    function scan() {
      scheduled = false;
      rows.forEach((state, slider) => {
        if (!root.contains(slider)) {
          state.resize.disconnect();
          slider.removeEventListener('scroll', state.update);
          state.nav.remove();
          rows.delete(slider);
        }
      });
      root.querySelectorAll('.slider-scroll-container').forEach(slider => {
        let state = rows.get(slider);
        if (!state) {
          const nav = document.createElement('div');
          nav.className = 'brw-rec-arrows';
          const buttons = [-1, 1].map(direction => {
            const button = document.createElement('button');
            button.type = 'button';
            button.setAttribute('aria-label', direction < 0 ? labels.dataset.previous : labels.dataset.next);
            button.title = button.getAttribute('aria-label');
            button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + (direction < 0 ? 'M14 6l-6 6 6 6' : 'M10 6l6 6-6 6') + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            button.addEventListener('click', () => {
              slider.scrollBy({left: direction * slider.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
            });
            nav.appendChild(button);
            return button;
          });
          const update = () => {
            const limit = slider.scrollWidth - slider.clientWidth;
            nav.hidden = limit < 2;
            buttons[0].disabled = slider.scrollLeft <= 1;
            buttons[1].disabled = slider.scrollLeft >= limit - 1;
          };
          const resize = new ResizeObserver(update);
          resize.observe(slider);
          slider.addEventListener('scroll', update, {passive: true});
          state = {nav, update, resize};
          rows.set(slider, state);
        }
        if (slider.parentElement.nextElementSibling !== state.nav) slider.parentElement.after(state.nav);
        state.update();
      });
    }
    new MutationObserver(records => {
      if (!records.some(record => record.addedNodes.length || record.removedNodes.length) || scheduled) return;
      scheduled = true;
      requestAnimationFrame(scan);
    }).observe(root, {childList: true, subtree: true});
    scan();
  }
  function discover() {
    document.querySelectorAll('[id^="reconvert-slot-"]').forEach(host => {
      if (host.shadowRoot) bindRoot(host.shadowRoot);
    });
  }
  new MutationObserver(discover).observe(document.body, {childList: true, subtree: true});
  let attempts = 0;
  const startup = setInterval(() => {
    discover();
    if (++attempts >= 30) clearInterval(startup);
  }, 500);
  discover();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["brw-spray-preorder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('brw-reservation-properties')) {
    customElements.define('brw-reservation-properties', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        if (!this.form) return;
        this.sync = () => {
          const id = this.form.querySelector('[name="id"]')?.value;
          this.querySelectorAll('[data-brw-reservation-variant]').forEach(group => {
            group.querySelectorAll('input').forEach(input => {
              input.disabled = group.dataset.brwReservationVariant !== id;
            });
          });
        };
        this.record = event => {
          const id = String(event.formData.get('id'));
          const group = Array.from(this.querySelectorAll('[data-brw-reservation-variant]')).find(group => group.dataset.brwReservationVariant === id);
          if (group) group.querySelectorAll('input').forEach(input => event.formData.set(input.name, input.value));
        };
        this.form.addEventListener('change', this.sync);
        this.form.addEventListener('formdata', this.record);
        this.sync();
      }
      disconnectedCallback() {
        this.form?.removeEventListener('change', this.sync);
        this.form?.removeEventListener('formdata', this.record);
      }
    });
  }

  if(!customElements.get('brw-preorder-window')){
    customElements.define('brw-preorder-window',class extends HTMLElement{
      connectedCallback(){
        this.checkExpiry=this.checkExpiry.bind(this);
        document.addEventListener('visibilitychange',this.checkExpiry);
        this.checkExpiry();
      }
      disconnectedCallback(){
        clearTimeout(this.expiryTimer);
        document.removeEventListener('visibilitychange',this.checkExpiry);
      }
      checkExpiry(){
        clearTimeout(this.expiryTimer);
        const remaining=Date.parse(this.dataset.expires)-Date.now();
        if(!Number.isFinite(remaining)||remaining<=0){
          if(this.dataset.fallback){this.textContent=this.dataset.fallback;}
          else{this.hidden=true;this.querySelectorAll('input').forEach(input=>input.disabled=true);}
          document.removeEventListener('visibilitychange',this.checkExpiry);
          return;
        }
        this.expiryTimer=setTimeout(this.checkExpiry,Math.min(remaining,3600000));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["brw-storefront-polish"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.brwWidgetPolishReady) return;
  window.brwWidgetPolishReady = true;
  const watched = new WeakSet();
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; sync(); });
  };
  const watch = root => {
    if (!root || watched.has(root)) return;
    watched.add(root);
    new MutationObserver(schedule).observe(root, {subtree:true,childList:true,attributes:true,attributeFilter:['class','open','aria-hidden','aria-expanded','data-current-step']});
  };
  const styleRoot = (root, css) => {
    if (!root) return;
    if (!root.querySelector('[data-brw-widget-style]')) {
      const style = document.createElement('style');
      style.dataset.brwWidgetStyle = '';
      style.textContent = css;
      root.append(style);
    }
    watch(root);
  };
  const accountCSS = `
    .floating-btn{right:var(--brw-widget-edge,20px)!important;left:auto!important;bottom:calc(var(--brw-widget-bottom,20px) + 60px)!important;width:48px!important;height:48px!important;padding:0!important;border-radius:50%!important;border:1px solid #c8d1c0!important;box-shadow:0 4px 14px #233c301a!important;z-index:30!important;animation:none!important}
    .floating-btn :is(.fa-account,.floating-btn-icon){width:24px!important;height:24px!important;font-size:24px!important}
    .floating-btn .btn-text{display:none}
    .floating-btn:focus-visible{outline:3px solid #a15c26;outline-offset:4px}
    :host([data-brw-hide-trigger]) .floating-btn{visibility:hidden!important;pointer-events:none!important}
    .widget{border-right:1px solid #d8dece}
    .menu{background:#eef1e7!important}.menu a.active{color:#274b3b!important}
  `;
  const chatCSS = `.activator-nudge{animation:none!important;transform:none!important;will-change:auto!important}.activator{width:max-content!important}.activator,.activator__label,.activator__icon{color:#fffdf8!important}.activator__label{white-space:nowrap}.activator__icon svg path{stroke:#fffdf8!important}@media(max-width:749px){.activator{width:48px!important;min-width:48px!important;padding:0!important;justify-content:center!important}.activator__label{display:none!important}.activator__icon{margin:0!important}}`;
  const creditCSS = `
    #app-embed[data-current-step="tease"]{left:var(--brw-widget-edge,20px)!important;bottom:calc(var(--brw-widget-bottom,20px) + 60px)!important;right:auto!important;top:auto!important;padding:0!important;width:auto!important;max-width:calc(100vw - 90px)!important;z-index:40!important}
    [data-testid="form-teaser"]{min-height:48px!important;background:#fffdf8!important;color:#274b3b!important;border:1px solid #c8d1c0!important;border-radius:24px!important;box-shadow:0 4px 14px #233c301a!important;padding:10px 28px 10px 14px!important}
    [data-testid="form-teaser"] h3{font:600 13px/1.3 var(--font-body-family,sans-serif)!important;color:#274b3b!important;margin:0!important}
    [data-testid="form-teaser"] svg{fill:#274b3b!important}
    :host{--form-background-color:#fffdf8!important;--body-text-color:#243d30!important;--heading-text-color:#243d30!important;--button-background-color:#274b3b!important;--button-text-color:#fffdf8!important;--forms-body-font:normal 400 14px var(--font-body-family,sans-serif)!important;--forms-heading-font:normal 600 22px var(--font-heading-family,sans-serif)!important}
  `;
  const shown = element => {
    if (!element) return false;
    const r = element.getBoundingClientRect();
    const css = getComputedStyle(element);
    return r.width > 0 && r.height > 0 && r.right > 0 && r.bottom > 0 && r.left < innerWidth && r.top < innerHeight && css.display !== 'none' && css.visibility !== 'hidden' && Number(css.opacity) > 0;
  };
  const flag = (element, name, state) => {
    if (element && element.hasAttribute(name) !== state) element.toggleAttribute(name,state);
  };
  function sync() {
    const account = document.querySelector('accounts-everywhere');
    const chat = document.querySelector('shopify-chat');
    const credit = document.querySelector('#app-embed-container-299255');
    const rewards = document.querySelector('.dbw-root');
    styleRoot(account?.shadowRoot,accountCSS);
    styleRoot(chat?.shadowRoot,chatCSS);
    styleRoot(credit?.shadowRoot,creditCSS);
    const runtime = chat?.shadowRoot?.querySelector('shopify-agent-runtime');
    styleRoot(runtime?.shadowRoot,chatCSS);
    const button = account?.shadowRoot?.querySelector('.floating-btn');
    if (button && !button.hasAttribute('aria-label')) {
      const label = document.querySelector('#brw-widget-labels')?.dataset.account;
      if (label) {button.setAttribute('aria-label',label);button.setAttribute('title',label);}
    }
    const accountOpen = !!account?.shadowRoot?.querySelector('.widget.open');
    const chatOpen = runtime?.hasAttribute('open') || !!chat?.shadowRoot?.querySelector('[role="dialog"]');
    const form = credit?.shadowRoot?.querySelector('[data-current-step]');
    const creditOpen = !!form && form.dataset.currentStep !== 'tease' && getComputedStyle(credit).display !== 'none' && form.getBoundingClientRect().width > 0;
    const rewardsOpen = !!rewards?.querySelector('.dbw-panel--open');
    const themeOpen = !!document.querySelector('quick-add-modal[open],product-modal[open],dialog[open],.mobile-facets__disclosure[open],#Details-menu-drawer-container[open]') || shown(document.querySelector('#swym-storefront-layout-container'));
    const active = themeOpen ? 'theme' : accountOpen ? 'account' : chatOpen ? 'chat' : creditOpen ? 'credit' : rewardsOpen ? 'rewards' : '';
    if (active) {if(document.body.dataset.brwWidgetPanel !== active) document.body.dataset.brwWidgetPanel=active;}
    else document.body.removeAttribute('data-brw-widget-panel');
    flag(account,'data-brw-hide-trigger',!!active || window.innerWidth <= 749 || document.body.classList.contains('brw-purchase-controls-visible'));
    flag(chat,'data-brw-suppressed',!!active && active !== 'chat');
    flag(credit,'data-brw-suppressed',!!active && active !== 'credit');
    flag(rewards,'data-brw-suppressed',!!active && active !== 'rewards');
  }
  const widgetSelector = 'accounts-everywhere,shopify-chat,#app-embed-container-299255,.dbw-root,#swym-storefront-layout-container';
  const panelSelector = 'quick-add-modal,product-modal,dialog,.mobile-facets__disclosure,#Details-menu-drawer-container';
  const relevantNode = node => node.nodeType === 1 && (
    node.matches(widgetSelector + ',' + panelSelector) ||
    node.closest(widgetSelector) ||
    node.querySelector(widgetSelector + ',' + panelSelector)
  );
  const pageChanged = records => {
    if (records.some(record => {
      if (record.type === 'attributes') {
        return record.target.matches(panelSelector) || !!record.target.closest(widgetSelector);
      }
      return !!record.target.closest?.(widgetSelector) ||
        [...record.addedNodes, ...record.removedNodes].some(relevantNode);
    })) schedule();
  };
  new MutationObserver(pageChanged).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class','open','aria-hidden','aria-expanded','data-current-step']
  });
  document.addEventListener('click',() => {schedule();setTimeout(schedule,350);},true);
  document.addEventListener('toggle',schedule,true);
  window.addEventListener('resize',schedule,{passive:true});
  window.addEventListener('scroll',schedule,{passive:true});
  sync();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["brw-wishlist-integration"] && !Shopify.designMode) return;
  try {
    (() => {
  let wishlistApi;
  const initialize = (modal) => {
    if (!wishlistApi || !modal?.isConnected) return;
    const button = modal.querySelector('.brw-quick-wishlist-button');
    if (!button) return;
    const variant = modal.querySelector('product-form input[name="id"]');
    if (variant?.value) button.dataset.variantId = variant.value;
    wishlistApi.initializeActionButtons('#' + CSS.escape(modal.id), '.brw-quick-wishlist-button');
  };
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push((swat) => {
    wishlistApi = swat;
    document.querySelectorAll('.brw-quick-view[open]').forEach(initialize);
  });
  document.addEventListener('brw:quick-view-ready', (event) => initialize(event.target));
  document.addEventListener('change', (event) => {
    if (!event.target.matches('product-form input[name="id"]')) return;
    const modal = event.target.closest('.brw-quick-view');
    if (modal) initialize(modal);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
